import { Router } from '@angular/router';
import { ChangeDetectionStrategy, Component, OnInit, Input, Inject } from '@angular/core';

import { Store } from '@ngrx/store';

import * as utils from '../../util';
import * as fromRoot from '../../reducers';
import * as olci from '../../actions/olci';
import * as tracking from '../../actions/tracking';
import { CONSTANTS } from '../../constants/constants';
import { GatingServices } from '../../modules/core/services/gating.services';
import { BookingService } from '../../modules/core/services/booking.service';
import { FeatureFlagsService } from 'src/app/modules/core/services/feature-flags.service'
import { FeatureFlagDictionaryEnum } from 'src/app/shared/enums/feature-flag-dictionary.enum'

@Component({
    selector: 'app-olci-checkin-component',
    templateUrl: './checkin.component.html',
    styleUrls: ['./checkin.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CheckInComponent implements OnInit {
	@Input() public isTravelQuestionnaireCompleted: any = true;
	@Input() public isGuestDetailsCompleted: any = true;
	@Input() public isOnboardExpensesCompleted: any = true;
	@Input() public isCruiseDetailsCompleted: any = true;
	@Input() public bundle: any;

	public navModel: any[];
	public showMenu: boolean;
	public smartship = false;
	public isSafari = false;
	public exitModal;
	public brandUrl;
	public brandName: string;
	public brandCorpAltText: string;
	public arrivalTimeEnabled = false;
  public shouldDisplayMessageCenter = false;

	constructor(
		private readonly router: Router,
		private readonly gatingServices: GatingServices,
		private readonly store: Store<fromRoot.AppState>,
		@Inject(CONSTANTS) public constants: any,
		private readonly bookingService: BookingService,
    private readonly featureFlagService: FeatureFlagsService,
	) {
		this.showMenu = false;
		this.smartship = this.bookingService.isSmartShip;
		this.exitModal = constants.MODAL.EXIT;
		this.brandUrl = this.gatingServices.getBrandURL();
	}

  get isProgressBarEnabled(): boolean {
    return this.bookingService.isProgressBarEnabled;
  }

	ngOnInit() {
    this.shouldDisplayMessageCenter = this.featureFlagService.snapshot[FeatureFlagDictionaryEnum.MESSAGING_CENTER];
		if(!this.bundle){
			return;
		}
		this.arrivalTimeEnabled = this.bookingService.isArrivalTimeEnabled;
		const arrival = {
			title: this.bundle['progress.bar.arrival'],
			url: this.constants.ROUTES.ARRIVAL_INFO,
			active: this.isActiveLink(this.constants.ROUTES.ARRIVAL_INFO)
		};

		this.navModel = [
			{
				title: this.bundle['progress.bar.guest'],
				url: this.constants.ROUTES.GUEST_DETAILS,
				active: this.isActiveLink(this.constants.ROUTES.GUEST_DETAILS)
			},
			{
				title: this.bundle['progress.bar.onboard.expenses'],
				url: this.constants.ROUTES.ONBOARD_EXPENSE,
				active: this.isActiveLink(this.constants.ROUTES.ONBOARD_EXPENSE)
			},
			{
				title: this.bundle['progress.bar.contracts'],
				url: this.constants.ROUTES.CRUISE_DETAILS,
				active: this.isActiveLink(this.constants.ROUTES.CRUISE_DETAILS)
			}
		];

		if (this.smartship && this.arrivalTimeEnabled) {
			this.navModel.push(arrival);
		}

		this.isSafari = utils.isSafari();
		this.brandName = this.bookingService.getBrand();
		this.brandCorpAltText = this.bookingService.getBrandCorpAltText();
	}

	goToBrandUrl(event: any) {
		event.preventDefault();
		this.store.dispatch(new olci.OpenModalAction({ name: this.exitModal, url: this.brandUrl }));
		this.store.dispatch(new tracking.TrackPageInteractionEventAction('brand icon'));
	}

	isActiveLink(link: any) {
		return this.router.routerState.snapshot.url === link;
	}
}
